import React from "react";

function FooterNewsletter() {
  return (
    <div className="col-lg-5 col-md-12 mb-5">
      <h5 className="text-primary text-uppercase mb-4" style={{ letterSpacing: "5px" }}>Boletín informativo</h5>
      <p>¡No te pierdas nada! Suscríbete a nuestro boletín informativo y mantente al tanto de las últimas novedades, tendencias, consejos y ofertas exclusivas directamente en tu bandeja de entrada. ¡Regístrate ahora y sé parte de nuestra comunidad informada!</p>
      <div className="w-100">
        <div className="input-group">
          <input type="text" className="form-control border-light" style={{ padding: "30px" }} placeholder="Ingresa tu email" />
          <div className="input-group-append">
            <button className="btn btn-primary px-4">Registrarme</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterNewsletter;